module.exports = __webpack_public_path__ + "img/nsystem-logo.d8fd676e.svg";